import ContractInits from "../config/contractsInit";
import { GetDashboardData } from "../../Config/graphQL";

export const GetDashboardDataAction = (address) => {
  return async (dispatch) => {
    try {
      if (!address) {
        throw "Address does not found at GetDashboardDataAction";
      }
      let res = await GetDashboardData(address);
      // console.log("Response of GetDashboardDataAction", res);
      dispatch({ type: "GET_DASHBOARD_DATA", payload: res });
    } catch (e) {
      console.error("Err at GetDashboardDataAction", e);
    }
  };
};

export const getBalance = (address) => {
  return async (dispatch, getState) => {
    try {
      const { web3js } = await ContractInits.init();
      let res = await (await ContractInits.initPhnxTokenContract()).methods
        .balanceOf(address)
        .call();
      res = await web3js.utils.fromWei(res.toString());
      // console.log("getBalance ==>>", res);
      dispatch({ type: "getBalance", payload: res });
    } catch (e) {
      console.error("ERROR getBalance => ", e);
    }
  };
};

export const getContractBalance = (contractAddress) => {
  return async (dispatch, getState) => {
    try {
      const { web3js } = await ContractInits.init();
      let res = await (await ContractInits.initPhnxTokenContract()).methods
        .balanceOf(contractAddress)
        .call();
      res = await web3js.utils.fromWei(res.toString());
      // console.log("balance of staking contract ==>", res);
      // console.log("props.contractBalance getContractBalance", res);
      dispatch({ type: "getContractBalance", payload: res });
    } catch (e) {
      console.error("Err at getContractBalance", e);
    }
  };
};

export const onGetTotalStakedToken = () => {
  return async (dispatch, getState) => {
    try {
      const { web3js } = await ContractInits.init();
      let res = await (await ContractInits.initPhnxStakingContract()).methods
        .totalStakedTokens()
        .call();
      // console.log("console of total -->", res);
      res = await web3js.utils.fromWei(res.toString());
      dispatch({ type: "getTotalStaked", payload: res });
    } catch (e) {
      // console.log("error in get staked -->", e);
    }
  };
};

export const onGetInterestRate = () => {
  return async (dispatch, getState) => {
    try {
      let res = await (await ContractInits.initPhnxStakingContract()).methods
        .ratio()
        .call();

      res = Math.ceil(res / 100);
      // console.log("ANOTHER RESPONSE", res);
      dispatch({
        type: "getInterest",
        payload: res,
      });
    } catch (e) {
      console.error("ERROR onGetInterestRate => ", e);
    }
  };
};

export const LogoutAppAction = () => {
  return {
    type: "LOGOUT_APP",
  };
};
